import { Component, OnInit, EventEmitter, Input, Output } from "@angular/core";
import { AssociateDto } from "@hub/generated/models";
import { eColumnType, eContactType } from "@hub/generated/enums";
import { PageLoaderService } from '@hub/services/index';
import { SubGridItem } from "@hub/models/common/ui/SubGridItem";
import { Functions } from "@hub/common/Functions";
@Component({
	selector: "hub-associates",
	templateUrl: "./associates.component.html"
})
export class AssociatesComponent implements OnInit {
	constructor(  public pageLoaderService: PageLoaderService
	) { }

	@Input() associations: AssociateDto[] = [];
	@Input() selection: AssociateDto[] = [];
	@Output() onDelete: EventEmitter<AssociateDto[]> = new EventEmitter<AssociateDto[]>();
	@Output() onOpenDialog: EventEmitter<any> = new EventEmitter<any>();
	@Output() onSelectItem: EventEmitter<AssociateDto[]> = new EventEmitter<AssociateDto[]>();

	public columns: SubGridItem[] = [
		{ Field: 'ContactType', Header: 'Type', ColumnType: eColumnType.PlainText },
		{ Field: 'Company', Header: 'Company', ColumnType: eColumnType.PlainText },
		{ Field: 'Comment', Header: 'Comment', ColumnType: eColumnType.PlainText },
	];

	ngOnInit(): void {
		this.getStringFromEnums(this.associations);
	}

	public onSelect(event: any) {
		this.selection = event;
		this.onSelectItem.emit(this.selection);
	}

	public openCreateOrEditDialog(event: boolean) {
		this.onOpenDialog.emit(event);
	}

	public delete() {
    this.onDelete.emit(this.selection);
	}

	private getStringFromEnums(data) {
		for (let i = 0; i < data.length; i++) {
			data[i].ContactTypeId = !!data[i].ContactTypeId ? Functions.getEnumName(eContactType, data[i].ContactTypeId) : data[i].ContactTypeId;
		}
	}
}
